// @ts-strict-ignore
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';

export class AccessoryTypeFilter {
  public static readonly LANGUAGE_KEY_TOP_RESULTS: string = 'accessories.topResults';
  public static readonly LANGUAGE_KEY_ALL_ACCESSORIES: string = 'viewArticlesPopup.radio.all_accessories';
  public static readonly LANGUAGE_KEY_END_PLATE: string = 'viewArticlesPopup.radio.end_plate';
  public static readonly LANGUAGE_KEY_BRIDGE: string = 'viewArticlesPopup.radio.bridge';
  public static readonly LANGUAGE_KEY_INSULATION_STOP: string = 'viewArticlesPopup.radio.insulation_stop';
  public static readonly LANGUAGE_KEY_PROTECTIVE_WARNING_MARKER: string = 'viewArticlesPopup.radio.protective_warning_marker';
  public static readonly LANGUAGE_KEY_STRAIN_RELIEF: string = 'viewArticlesPopup.radio.strain_relief';
  public static readonly LANGUAGE_KEY_LABELING: string = 'viewArticlesPopup.radio.labeling';
  public static readonly LANGUAGE_KEY_MARKER_CARRIER: string = 'viewArticlesPopup.radio.marker_carrier';
  public static readonly LANGUAGE_KEY_LOCKING: string = 'viewArticlesPopup.radio.locking';
  public static readonly LANGUAGE_KEY_END_STOP: string = 'viewArticlesPopup.radio.end_stop';
  public static readonly LANGUAGE_KEY_CODING_KEY: string = 'viewArticlesPopup.radio.coding_key';
  public static readonly LANGUAGE_KEY_WIRE_FERRULE: string = 'viewArticlesPopup.radio.wire_ferrule';
  public static readonly LANGUAGE_KEY_WIRE_BRIDGE: string = 'viewArticlesPopup.radio.wire_bridge';
  public static readonly LANGUAGE_KEY_MCS_CONNECTORS: string = 'viewArticlesPopup.radio.mcs_connectors';
  public static readonly LANGUAGE_KEY_OTHER_ACCESSORIES: string = 'viewArticlesPopup.radio.other_accessories';

  public localizationKey: string;
  public includedArticleTypes: string[];
  public excludedArticleTypes: string[];

  constructor(localizationKey: string, includedArticleTypes: string[], excludedArticleTypes: string[], private localeResourceManager: LocaleResourceManager) {
    this.localizationKey = localizationKey;
    this.includedArticleTypes = includedArticleTypes;
    this.excludedArticleTypes = excludedArticleTypes;
  }

  public get label(): string {
    return this.localeResourceManager.getValueByKey(this.localizationKey);
  }
}

export class AccessoryTypeFiltersBuilder {
  private typeFilters: AccessoryTypeFilter[] = [];

  constructor(private localeResourceManager: LocaleResourceManager) {
  }

  public addInclusionFilter(localizationKey: string, includedArticleTypes: string[]): this {
    this.typeFilters.push(new AccessoryTypeFilter(localizationKey, includedArticleTypes, undefined, this.localeResourceManager));
    return this;
  }

  public addExclusionFilter(localizationKey: string, excludedArticleTypes: string[]): this {
    this.typeFilters.push(new AccessoryTypeFilter(localizationKey, undefined, excludedArticleTypes, this.localeResourceManager));
    return this;
  }

  public build(): AccessoryTypeFilter[] {
    return this.typeFilters;
  }
}
